import { defineMessages } from "@/i18n";
import en from "./en";

export const framesMemoryMessages = defineMessages("frames-memory", en);
